export const baseURL = 'https://dpinterface.djplus.cn'
// export const baseURL = 'http://192.168.2.12:16928'
export const sourceURL = 'https://dpadmin.djplus.cn'

// export const baseURL = 'http://192.168.2.212:16928'
// export const sourceURL = 'http://192.168.2.212:16928'


// export const baseURL = 'http://dpinterface.djyun.com.cn:15001'
// export const sourceURL = 'http://dpinterface.djyun.com.cn:15001'

// export const baseURL = 'http://172.22.70.33:15001'
// export const sourceURL = 'http://172.22.70.33:15001
